import {FormProvider, type SubmitHandler, type UseFormReturn,} from 'react-hook-form';
import {type ReactNode} from 'react';
import {cn} from '@/lib/utils';

export type Orientation = 'horizontal' | 'vertical' | 'responsive';

export type TLabelValue = {
  label: string;
  value: any;
};

type AppFormProps = {
  form: UseFormReturn<any>;
  className?: string;
  onSubmit?: SubmitHandler<any>;
  children: ReactNode;
};

export function AppForm({form, className, onSubmit, children}: AppFormProps) {
  const _handleSubmit = (values: any, e: any) => {
    if (onSubmit) {
      onSubmit(values, e);
    }
  };
  return (
    <FormProvider {...form}>
      <form
        className={cn('app-form', className)}
        onSubmit={form.handleSubmit(_handleSubmit)}
      >
        {children}
      </form>
    </FormProvider>
  );
}
